import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import cx from 'classnames';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import BaseTable from '@studionand/ada-next/src/components/Media/BaseTable';
import withStores from '@studionand/ada-next/src/stores/withStores';
import CloseIcon from '../../../../../shared/icons/Close';
import ContentEditable from './ContentEditable';
import { Image, RESPONSVE_SIZES_CARDS } from '@studionand/ada-next/src/components/Media/Image';
const styles = theme => ({
  container: {
    padding: theme.spacing(1),
    position: 'relative',
  },
  placeholder: {
    ...theme.typography.body2,
    '&:empty:after': {
      content: 'attr(placeholder)',
    },
    '&$title': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  link: {
    display: 'block',
  },
  hover: {
    color: theme.editorPalette.primary.main,
    '&:hover': {
      color: theme.editorPalette.primary.light,
    },
  },
  title: {},
  img: {
    position: 'relative',
    height: 250,
    width: '100%',
    backgroundColor: theme.editorPalette.grey[200],
    '&:hover $editable': {
      backgroundColor: theme.editorPalette.grey[300],
    },
  },
  editable: {
    cursor: 'pointer',
  },
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '80%',
    height: '80%',
    background: theme.editorPalette.common.white,
    overflow: 'auto',
    transform: 'translate(-50%, -50%)',
  },
  deleteButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
});

const Anchor = withStyles(styles)(
  ({ classes, className, isEditable, ...props }) => {
    return (
      <Typography
        className={cx(classes.link, className, {
          [classes.hover]: !isEditable,
        })}
        component={isEditable ? 'div' : 'a'}
        variant="body2"
        {...props}
      />
    );
  },
);

@withStores('appStore')
@observer
class AnsprechpartnerBox extends Component {
  static defaultProps = {
    title: null,
    tel: null,
    img: null,
    email: null,
  };
  static propTypes = {
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    tel: PropTypes.string,
    img: PropTypes.string,
    email: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    onReceiveInput: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onSetImage: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
  };
  state = {
    showModal: false,
  };
  handleOpenModal = e => {
    if (!this.props.isEditable) return;
    e.stopPropagation();
    e.preventDefault();
    this.props.appStore.setPaused(true);
    this.setState({
      showModal: true,
    });
    this.props.onOpenModal();
  };
  handleCloseModal = () => {
    this.setState({
      showModal: false,
    });
    this.props.onCloseModal();
  };
  handleSelectItem = item => {
    this.props.onSetImage(this.props.uuid, item.uuid);
    this.handleCloseModal();
  };
  render() {
    const {
      name,
      img,
      uuid,
      title,
      tel,
      email,
      isEditable,
      readOnly,
      onRemove,
      onReceiveInput,
      appStore,
      classes,
    } = this.props;
    return (
      <div className={classes.container}>
        <div
          className={cx(classes.img, { [classes.editable]: !readOnly })}
          onClick={this.handleOpenModal}
        >
          <Image
            assetId={img}
            layout="fill"
            objectFit="cover"
            objectPosition="top center"
            sizes={RESPONSVE_SIZES_CARDS}
          />
        </div>

        {!appStore.editMode && !name ? null : (
          <ContentEditable
            className={cx(classes.placeholder, classes.title)}
            placeholder="Name"
            onInput={e => {
              onReceiveInput(e, uuid, 'name');
            }}
            contentEditable={isEditable}
            suppressContentEditableWarning
          >
            {name}
          </ContentEditable>
        )}
        {!appStore.editMode && !title ? null : (
          <ContentEditable
            className={cx(classes.placeholder)}
            placeholder="Bereich"
            onInput={e => {
              onReceiveInput(e, uuid, 'title');
            }}
            contentEditable={isEditable}
            suppressContentEditableWarning
          >
            {title}
          </ContentEditable>
        )}
        {!appStore.editMode && !tel ? null : (
          <ContentEditable
            className={cx(classes.placeholder)}
            placeholder="Telefonnr."
            elem={Anchor}
            onInput={e => {
              onReceiveInput(e, uuid, 'tel');
            }}
            isEditable={appStore.editMode}
            contentEditable={isEditable}
            suppressContentEditableWarning
            size="s"
            href={`tel:${tel}`}
          >
            {tel}
          </ContentEditable>
        )}
        {!appStore.editMode && !email ? null : (
          <ContentEditable
            className={classes.placeholder}
            placeholder="E-Mail"
            elem={Anchor}
            onInput={e => {
              onReceiveInput(e, uuid, 'email');
            }}
            isEditable={appStore.editMode}
            contentEditable={isEditable}
            suppressContentEditableWarning
            size="s"
            href={`mailto:${email}`}
          >
            {email}
          </ContentEditable>
        )}
        {isEditable && (
          <IconButton
            className={classes.deleteButton}
            onClick={() => {
              onRemove(uuid);
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <Modal
          open={this.state.showModal}
          onClose={this.handleCloseModal}
          disableEnforceFocus={false}
          disableRestoreFocus={false}
          onClick={e => {
            // we need to do that to prevent atomic block loose focus on interaction within the modal
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div className={classes.modalContent}>
            <BaseTable onSelectItem={this.handleSelectItem} />
          </div>
        </Modal>
      </div>
    );
  }
}

export default withStyles(styles)(AnsprechpartnerBox);
